import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconCode: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6875 1.875H5.3125C3.09583 1.875 1.875 3.09583 1.875 5.3125V14.6875C1.875 16.9042 3.09583 18.125 5.3125 18.125H14.6875C16.9042 18.125 18.125 16.9042 18.125 14.6875V5.3125C18.125 3.09583 16.9042 1.875 14.6875 1.875ZM16.875 14.6875C16.875 16.2208 16.2208 16.875 14.6875 16.875H5.3125C3.77917 16.875 3.125 16.2208 3.125 14.6875V5.3125C3.125 3.77917 3.77917 3.125 5.3125 3.125H14.6875C16.2208 3.125 16.875 3.77917 16.875 5.3125V14.6875ZM8.12668 8.59001L6.7175 10L8.12749 11.41C8.37166 11.6542 8.37166 12.05 8.12749 12.2942C8.00583 12.4158 7.84583 12.4775 7.68583 12.4775C7.52583 12.4775 7.36583 12.4167 7.24416 12.2942L5.39251 10.4425C5.14834 10.1983 5.14834 9.8025 5.39251 9.55833L7.24416 7.70665C7.48833 7.46249 7.88416 7.46249 8.12833 7.70665C8.37083 7.94999 8.37084 8.34584 8.12668 8.59001ZM14.6083 9.55833C14.8525 9.8025 14.8525 10.1983 14.6083 10.4425L12.7567 12.2942C12.635 12.4158 12.475 12.4775 12.315 12.4775C12.155 12.4775 11.995 12.4167 11.8733 12.2942C11.6292 12.05 11.6292 11.6542 11.8733 11.41L13.2833 10L11.8733 8.59001C11.6292 8.34584 11.6292 7.95001 11.8733 7.70584C12.1175 7.46167 12.5133 7.46167 12.7575 7.70584L14.6083 9.55833ZM11.44 6.81834L9.77333 13.485C9.7025 13.7692 9.44751 13.9583 9.16751 13.9583C9.11751 13.9583 9.06666 13.9525 9.01499 13.9392C8.67999 13.8558 8.47668 13.5158 8.56084 13.1817L10.2275 6.51499C10.3108 6.17999 10.6467 5.97667 10.9858 6.06C11.32 6.14417 11.5233 6.48334 11.44 6.81834Z"
      fill={disabled ? 'rgba(92, 101, 110, 1)' : color}
    />
  </svg>
);

export default IconCode;
